window.PXUTheme = window.PXUTheme || {};
var __webpack_exports__ = {};

window.PXUTheme.jsCart = {
  init: function ($section) {
    window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.cartEl = document.getElementById("cart");
    this.cartContent = document.querySelector(".cart__container");
    this.cartEmpty = document.querySelector(".cart__empty");
    this.cartItemCount = document.querySelector("[data-cart-item-count]");
    this.cartIconCount = document.querySelector(".cart-count");
    this.cartItemContent = document.querySelector("[data-cart-content]");
    this.checkoutButton = document.querySelector("[data-cart-checkout]");
    this.cartUpsells = document.querySelector("[data-cart-upsells]");
    this.freeShippingEl = document.querySelector("[data-cart-free-shipping]");
    this.moneyFormat = document.querySelector("body").dataset.moneyFormat;
    this.cartFooter = document.querySelector("[data-cart-footer]");
    this.cart = {};
    this.cartNote = document.querySelector("[data-cart-note]");
    this.country = null;
    this.showYMAL = false;
    this.html = document.querySelector("html");

    const checkCountry = () => {
      this.country = document.body.getAttribute("data-fetched-country");
      if (this.country) {
        // Proceed with initialization
        this.updateCart();
        this.toggleListeners();
        this.watchAtcButtons();
        this.watchLegacyAtcButtons();
        this.watchBackground();
        this.addFooterText();
        this.watchCartNote();
      } else {
        setTimeout(checkCountry, 100); // Retry every 100ms
      }
    };
    checkCountry();
  },

  watchBackground() {
    document.querySelector(".cart__background").addEventListener("click", () => {
      this.hideCart();
    });
  },

  calculateFreeShipping() {
    let freeShippingAmount = 0;
    if (this.country == "United Kingdom") {
      freeShippingAmount = this.free_shipping_amount_uk;
    }
    if (this.country == "United States") {
      freeShippingAmount = this.free_shipping_amount_us;
    }
    if (freeShippingAmount > 0 && this.cart.total_price < freeShippingAmount) {
      let shippingWidth = (this.cart.total_price / freeShippingAmount) * 100;
      document.querySelector(":root").style.setProperty("--free-shipping-width", `${shippingWidth}%`);
      this.freeShippingEl.querySelector("span").innerHTML = `<strong>${this.formatter(freeShippingAmount - this.cart.total_price)}</strong> away from free delivery`;

      // Uncomment to re-enable free shipping header thing
      // this.freeShippingEl.classList.remove('hidden');
    }
    if (freeShippingAmount > 0 && this.cart.total_price >= freeShippingAmount) {
      let shippingWidth = (this.cart.total_price / freeShippingAmount) * 100;
      document.querySelector(":root").style.setProperty("--free-shipping-width", `${shippingWidth}%`);
      this.freeShippingEl.querySelector("span").innerHTML = "You’ve qualified for Free Delivery!";

      // Uncomment to re-enable free shipping header thing
      // this.freeShippingEl.classList.remove('hidden');
    }
    if (freeShippingAmount == 0) {
      this.freeShippingEl.classList.add("hidden");
    }
    if (this.cart.items) {
      if (this.cart.items.length == 0) {
        this.freeShippingEl.classList.add("hidden");
      }
    }
  },

  watchLegacyAtcButtons() {
    const legacyButtons = document.querySelectorAll(".ajax-submit");
    legacyButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const addToCartForm = event.target.closest("form");
        this.legacyAddToCart(addToCartForm);
      });
    });
  },

  legacyAddToCart(addToCartForm) {
    // Wrap addToCartForm in jQuery
    const $addToCartForm = $(addToCartForm);
    this.cartEl.classList.add("disabled");
    const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
    $addToCartForm.removeClass("shopify-product-form--unselected-error");
    let $continue = true;

    if (document.querySelector("body").classList.contains("product-2-1")) {
      if ($addToCartBtn[0].closest(".purchase-details").dataset.selectionStep === "false") {
        $continue = false;
      }
    }

    if ($continue == true) {
      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $(".warning").remove();

        $addToCartForm.addClass("shopify-product-form--unselected-error").find(".cart-warning").html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("loading");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn.find("span:not(.icon)").text($addToCartBtn.data("label")).removeClass("zoomOut").addClass("zoomIn");
      } else {
        let urlParams = new URLSearchParams(document.location.search);
        let cartData;

        if (this.country !== "United Kingdom" && this.country !== "United States") {
          cartData = {
            items: [],
          };
        } else {
          cartData = window.PXUTheme.productSectionInstance.getSubscriptionCartData();
        }

        let formData = new FormData($addToCartForm[0]);
        let temp = {};
        let include = true;

        for (let [key, value] of formData.entries()) {
          if (key === "id") {
            let existingItem = cartData.items.find((item) => item.id.toString() === value.toString());
            if (!existingItem) {
              temp["id"] = value;
            } else {
              include = false;
            }
          }

          if (key === "quantity" || key === "selling_plan") {
            if (include) {
              temp[key] = value;
            }
          }
        }

        if (include) {
          cartData.items.push(temp);
        }

        window._conv_q = window._conv_q || [];
        _conv_q.push(["triggerConversion", "100452543"]);

        $.ajax({
          url: window.PXUTheme.routes.cart_add_url,
          dataType: "json",
          cache: false,
          method: "post",
          data: cartData,
          beforeSend: function () {
            $addToCartBtn.attr("disabled", "disabled").addClass("loading");
          },
          success: (product) => {
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $("#header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");

              $addToCartBtn.find("span").removeClass("fadeInDown");
            }

            window.setTimeout(function () {
              $addToCartBtn.removeAttr("disabled").removeClass("loading");

              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

              $addToCartBtn.find(".text, .icon").removeClass("zoomOut").addClass("fadeInDown");

              $addToCartBtn.on("webkitAnimationEnd oanimationend msAnimationEnd animationend", addedToCart);
            }, 1000);

            this.updateCart();
            this.showCart();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: "html",
                url: window.PXUTheme.routes.cart_url,
                success: function (html) {
                  const cartForm = $(html).find(".cart__form");
                  $(".cart__form").replaceWith(cartForm);
                },
              });
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace("All 1 ", "All ")}</p>`;

            $(".warning").remove();

            $addToCartForm.find(".cart-warning").html(cartWarning);

            $addToCartBtn.removeAttr("disabled").removeClass("loading");

            $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

            $addToCartBtn.find("span:not(.icon)").text($addToCartBtn.data("label")).removeClass("zoomOut").addClass("zoomIn");
          },
        });
      }
    }
  },

  showCart() {
    const cart = document.getElementById("cart");
    cart.classList.add("active");
    this.html.classList.add("noscroll");
  },

  hideCart() {
    const cart = document.getElementById("cart");
    cart.classList.remove("active");
    this.html.classList.remove("noscroll");
  },

  toggleCart(method = false) {
    const cart = document.getElementById("cart");
    if (method && method == "show") {
      cart.classList.add("active");
      this.html.classList.add("noscroll");
    } else if (method && method == "hide") {
      cart.classList.remove("active");
      this.html.classList.remove("noscroll");
    } else if (cart.classList.contains("active")) {
      cart.classList.remove("active");
      this.html.classList.remove("noscroll");
    } else {
      cart.classList.add("active");
      this.html.classList.add("noscroll");
    }
  },

  toggleListeners() {
    const allToggles = document.querySelectorAll("[data-cart-toggle]");
    for (const toggle of allToggles) {
      toggle.addEventListener("click", () => this.toggleCart());
    }
  },

  watchAtcButtons(parent = false) {
    let allButtons = [];
    if (parent) {
      allButtons = parent.querySelectorAll("[data-atc]");
    } else {
      allButtons = document.querySelectorAll("[data-atc]");
    }

    for (const button of allButtons) {
      button.addEventListener("click", (event) => {
        event.preventDefault();

        this.cartEl.classList.add("disabled");

        const target = event.currentTarget;
        const variantId = parseInt(target.dataset.atc, 10); // Parse variant ID
        const quantity = target.dataset.atcQty !== undefined ? parseInt(target.dataset.atcQty, 10) : 1; // Default to 1 if not set

        if (isNaN(variantId)) {
          console.error("Invalid or missing variant ID.");
          return;
        }

        if (isNaN(quantity)) {
          console.error("Invalid quantity specified.");
          return;
        }

        if (quantity > 0) {
          // Add items to cart
          const addData = {
            items: [
              {
                id: variantId,
                quantity: quantity,
              },
            ],
          };

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            body: JSON.stringify(addData),
            credentials: "same-origin",
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then((json) => {
              this.updateCart();
              this.showCart();
            })
            .catch((err) => {
              console.error("Error adding to cart:", err);
            });
        } else if (quantity === 0) {
          // Remove all matching items from the cart
          fetch("/cart.js", {
            method: "GET",
            headers: {
              "X-Requested-With": "xmlhttprequest",
            },
            credentials: "same-origin",
          })
            .then((response) => response.json())
            .then((cart) => {
              const updates = cart.items.reduce((acc, item) => {
                if (item.variant_id === variantId) {
                  acc[item.variant_id] = 0; // Remove all matching items
                }
                return acc;
              }, {});

              return fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "xmlhttprequest",
                },
                body: JSON.stringify({ updates }),
                credentials: "same-origin",
              });
            })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then((json) => {
              this.updateCart();
            })
            .catch((err) => {
              console.error("Error removing items from cart:", err);
            });
        } else if (quantity < 0) {
          // Set the quantity to the absolute value (flip to positive)
          const updates = {
            [variantId]: Math.abs(quantity), // Use absolute value
          };

          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
            body: JSON.stringify({ updates }),
            credentials: "same-origin",
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then((json) => {
              this.updateCart();
            })
            .catch((err) => {
              console.error("Error adjusting cart:", err);
            });
        }
      });
    }
  },

  renderItemOptions(options) {
    let html = ``;
    let bundleValue = "";
    let colourValue = "";

    options.forEach((option) => {
      if (option.value != "Default Title") {
        if (option.name === "Bundle") {
          bundleValue = option.value;
        } else if (option.name === "Colour" || option.name === "Color") {
          colourValue = option.value;
        } else {
          html += `<p class="property">${option.name}: ${option.value}</p>`;
        }
      }
    });

    // Combine Bundle and Colour if present
    if (bundleValue || colourValue) {
      const combined = [bundleValue, colourValue].filter(Boolean).join(" / ");
      html += `<p class="property">${combined}</p>`;
    }

    return html;
  },

  renderItemProperties(properties) {
    let html = ``;
    Object.entries(properties).forEach(([key, value]) => {
      if (Array.from(key)[0] != "_") {
        html += `<p class="property">${key}: ${value}</p>`;
      }
    });
    return html;
  },

  formatter(price) {
    return price === 0 ? window.PXUTheme.translation.free_price_text : Shopify.formatMoney(price, this.moneyFormat);
  },

  async renderItemPrice(item) {
    let allProducts = window.allProductUpsells;
    allProducts.forEach((product) => {
      if (product.id == item.variant_id) {
        if (product.compare_price !== "false" && product.compare_price > 0) {
          item.original_price = parseInt(product.compare_price);
        }
      }
    });

    let html = '';

    const isEnabled = document.body.getAttribute("data-intelligems-enabled") === "true";

    if (isEnabled) {
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error("Intelligems timeout")), 5000);
        const checkExist = setInterval(() => {
          if (window.igData && Object.keys(window.igData).length > 0) {
            clearTimeout(timeout);
            clearInterval(checkExist);
            resolve();
          }
        }, 100);
      });

      item.ig_final_price = window.igData?.price?.getPriceByVariantId(item.id) * 100;
      item.ig_original_price = window.igData?.price?.getComparePriceByVariantId(item.id) * 100;
    }

    const final = item.ig_final_price > 0 ? item.ig_final_price : item.final_price;
    const original = item.ig_original_price > 0 ? item.ig_original_price : item.original_price;

    const savings = Math.round(((original - final) / original) * 100);

    html += `<p class="price"><span>${this.formatter(final)}</span>`;
    if (final !== original && final !== 0) {
      html += `&nbsp;<span class="compare-text">${this.formatter(original)}</span>
              <span class="slabel slabel-green">${savings}% off</span></p>`;
    } else {
      html += `</p>`;
    }

    return html;
  },


  renderDiscounts(item) {
    let discountHTML = '';
    discountHTML += `<div class="discounts">`;
    if(item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
      item.line_level_discount_allocations.forEach((discount) => {
        discountHTML += `<p><span class="gicon gicon--tag"></span> ${discount.discount_application.title} applied</p>`;
      })
    }
    discountHTML += `</div>`;
    return discountHTML;
  },

  renderSellingPlan(alloc) {
    if (alloc === undefined) return "";
    const selling_plan_name = alloc.selling_plan.name;
    return `<p class="property">${selling_plan_name}</p>`;
  },

  renderTotalSavings() {    
    let totalSavings = 0;

    for (const item of this.cart.items) {
      let allProducts = window.allProductUpsells;
      allProducts.forEach((product) => {
        if (product.id == item.variant_id) {
          if (product.compare_price !== "false" && product.compare_price > 0) {
            // item.final_price = product.price;
            item.original_price = parseInt(product.compare_price);
          }
        }
      });
      const currSaving = item.original_price - item.final_price;
      totalSavings += currSaving * item.quantity;
    }

    // Build the cart content
    let cartContent = `<div class="cart__discounts">`;
    cartContent += `<div class="cart__total">
                      <div><strong>Total Savings</strong></div><span><strong>${this.formatter(totalSavings)}</strong></span>
                    </div>`;
    cartContent += `</div>`;

    if(totalSavings == 0) {
      cartContent = ``;
    }

    // Output the final content
    return cartContent;
  },

  updateCart() {
    (async () => {
      try {
        const response = await fetch("/cart.js", {
          method: "GET",
          cache: "no-store",
        });

        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const cart = await response.json();
        this.cart = cart;
        let cartContent = "";

        if (cart.attributes["gift-message"]) {
          this.cartNote.querySelector("textarea").value = cart.attributes["gift-message"];
        }

        if (cart.items.length == 0) {
          this.cartFooter.classList.add("hidden");
          this.cartContent.classList.add("hidden");
          this.cartItemCount.classList.add("hidden");
          this.cartEmpty.classList.remove("hidden");
        } else {
          this.cartFooter.classList.remove("hidden");
          this.cartContent.classList.remove("hidden");
          this.cartItemCount.classList.remove("hidden");
          this.cartEmpty.classList.add("hidden");
        }

        this.cartUpsells.innerHTML = "";

        let discountCodes = [];

        // 🟡 Preload all price HTML blocks asynchronously
        const renderedPrices = await Promise.all(
          cart.items.map((item) => this.renderItemPrice(item))
        );

        let region = document.querySelector("body").dataset.selectedRegion;
        if (region != "GB") {
          switch(region) {
            case "US":
              var urlPart = '/en-us';
              break;
            case "CA":
              var urlPart = '/en-ca';
              break;
            case "BG":
              var urlPart = '/en-de';
              break;
            default:
              var urlPart = '';
          }
        } else {
          var urlPart = '';
        }

        console.log('Url Part:', urlPart);

        cart.items.forEach((item, index) => {
          cartContent += `<div class="cart__item" data-cart-item-id="${item.variant_id}">
              <div class="cart__item-image"><a href="${urlPart+item.url}" title="${item.product_title}"><img src="${item.image}" alt="${item.product_title}" /></a></div>
              <div class="cart__item-content">
                <p class="title"><a href="${urlPart+item.url}" title="${item.product_title}">${item.product_title}</a></p>
                ${this.renderItemOptions(item.options_with_values)}
                ${this.renderItemProperties(item.properties)}
                ${this.renderSellingPlan(item.selling_plan_allocation)}
                ${renderedPrices[index]}
                ${this.renderDiscounts(item)}
                <div class="cart__item-buttons">
                  <div class="left ${item.price === 0 ? "hidden" : ""}">
                    <div class="minus ${item.product_id == "7765365227708" && item.quantity == 2 ? "disabled" : ""}" data-atc="${item.variant_id}" data-atc-qty="-${item.quantity - 1}"><svg width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M13.6454 8.85679L13.6454 8.18738H8.65795L7.98854 8.19857V8.18738L3.00109 8.18738L3.00109 8.85679L7.98854 8.85679L8.65795 8.85679L13.6454 8.85679Z" fill="#252525"/></svg></div>
                    <div class="count" data-cart-item-count>${item.quantity}</div>
                    <div class="plus" data-atc="${item.variant_id}" data-atc-qty="-${item.quantity + 1}"><svg width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M13.3113 8.19078L13.3113 7.52137L8.32385 7.52137L8.32385 2.53392L7.65444 2.53392L7.65444 7.52137L2.66699 7.52137L2.66699 8.19078L7.65444 8.19078L7.65444 13.1782L8.32385 13.1782L8.32385 8.19078L13.3113 8.19078Z" fill="#252525"/></svg></div>
                  </div>
                  <div class="right">
                    <div class="remove" data-atc="${item.variant_id}" data-atc-qty="0">Remove</div>
                  </div>
                </div>
              </div>
            </div>`;

          this.renderLineItemUpsells(item.id);

          if (item.line_level_discount_allocations.length > 0) {
            for (const discount of item.line_level_discount_allocations) {
              discountCodes.push({
                [discount.discount_application.title]: discount.discount_application.total_allocated_amount,
              });
            }
          }
        });

        if (discountCodes.length > 0) {
          cartContent += this.renderTotalSavings();
        }

        // 🔄 Update DOM after prices are fully rendered
        this.cartItemContent.innerHTML = cartContent;
        document.querySelector("[data-cart-checkout]").textContent = `Checkout - ${this.formatter(cart.total_price)}`;
        this.cartItemCount.textContent = `${cart.item_count} items`;
        this.cartIconCount.textContent = cart.item_count > 0 ? cart.item_count : "";

        this.cartUpsells.innerHTML += this.renderUpsellProducts();
        this.cartUpsells.closest(".cart__upsells").classList.remove("hidden");
        this.watchAtcButtons(document.querySelector("#cart"));
        this.calculateFreeShipping();

        if (this.showYMAL == false) this.cartUpsells.closest(".cart__upsells").classList.add("hidden");

        const numberOfUpsells = document.querySelectorAll(".cart__upsells-wrapper > div").length;
        if (numberOfUpsells == 0) {
          this.cartUpsells.closest(".cart__upsells").classList.add("hidden");
        }

        if ((!this.cartUpsells.flickityInstance && window.innerWidth > 768 && numberOfUpsells > 3) || (window.innerWidth < 768 && numberOfUpsells > 2)) {
          this.cartUpsells.flickityInstance = new Flickity(this.cartUpsells, {
            wrapAround: true,
            dots: false,
            prevNextButtons: false,
            imagesLoaded: true,
            autoPlay: true,
            cellAlign: "left",
          });
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }

      this.cartEl.classList.remove("disabled");
      this.calculateFreeShipping();

      if (document.body.getAttribute("data-intelligems-enabled") === "true") {
        window.PXUTheme.jsGlobalProduct.initIntelligems();
      }
    })();
  },


  renderUpsellProducts() {
    let region = document.querySelector("body").dataset.selectedRegion;
    let upsellProducts = window.upsell_products_uk;
    let html = ``;

    if (region == "US" || region == "CA") {
      upsellProducts = window.upsell_products_us;
    }

    upsellProducts.forEach((product) => {
      if (this.cart.items.find((item) => item.id == product.variants[0].id)) {
        return false;
      } else {
        html += `
          <div class="cart__upsells-item">
            <a href="/products/${product.handle}">
              <img src="${product.featured_image}" alt="${product.title}" />
              <div class="cart__upsells-title">${product.title}</div>
              <div class="cart__upsells-price">${Shopify.formatMoney((product.price / 100).toFixed(2), document.body.getAttribute("data-money-format"))}</div>
            </a>
            <div class="btn btn--outline btn--block btn--smaller" data-atc="${product.variants[0].id}">Add</div>
          </div>
        `;
        this.showYMAL = true;
      }
    });

    return html;
  },

  renderLineItemUpsells(id) {
    let html = ``;

    // Initialize renderedUpsellProductIds only once
    if (!this.renderedUpsellProductIds) {
      this.renderedUpsellProductIds = [];
    }

    // Find the line item in allProductUpsells with the given ID
    const lineItem = window.allProductUpsells.find((item) => item.id === id);
    if (lineItem && lineItem.upsell_product) {
      const upsellProduct = window.allProductUpsells.find((item) => item.id === lineItem.upsell_product);
      if (upsellProduct) {
          if (this.renderedUpsellProductIds.includes(upsellProduct.id)) {
            return false; // Skip if the product ID is already rendered
          }
          // Add the product ID to the array and render only once
          this.renderedUpsellProductIds.push(upsellProduct.id);

          html += `
            <div class="cart__upsells-item">
              <a href="${upsellProduct.url}">
                <img src="${upsellProduct.image}" alt="Upsell for ${upsellProduct.id}" />
                <div class="cart__upsells-title">${upsellProduct.title}</div>
                <div class="cart__upsells-price">${Shopify.formatMoney((upsellProduct.price / 100).toFixed(2), document.body.getAttribute("data-money-format"))}</div>
              </a>
              <div class="btn btn--outline btn--block btn--smaller" data-atc="${upsellProduct.id}">Add</div>
            </div>
          `;
          this.showYMAL = true;
      }
    }

    this.cartUpsells.innerHTML += html;
  },

  renderShippingDays(minDays, maxDays, includeWeekends) {
    const today = new Date();

    // Helper function to add days while considering weekends
    function addDays(date, days, includeWeekends) {
      let result = new Date(date);
      while (days > 0) {
        result.setDate(result.getDate() + 1);
        if (includeWeekends || (result.getDay() !== 0 && result.getDay() !== 6)) {
          days--;
        }
      }
      return result;
    }

    // Format the date as "Day, Month Day"
    function formatDate(date) {
      const options = { weekday: "short", month: "short", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    }

    const minDeliveryDate = addDays(today, minDays, includeWeekends);
    const maxDeliveryDate = addDays(today, maxDays, includeWeekends);

    const formattedMinDate = formatDate(minDeliveryDate);
    const formattedMaxDate = formatDate(maxDeliveryDate);

    return `<p>Est. delivery <strong>${formattedMinDate}</strong> to <strong>${formattedMaxDate}</strong></p>`;
  },

  addFooterText() {
    let extraText = '<div class="cart__footer-text">';

    if (this.country == "United Kingdom") {
      extraText += `<p>Free standard delivery over ${this.formatter(this.free_shipping_amount_uk)}</p>`;
      extraText += `<p>Next day delivery £2.99 (excl. Sundays)</p>`;
      // extraText += this.renderShippingDays(this.shipping_days_min_uk, this.shipping_days_max_uk, this.include_weekends_uk);
    } else if (this.country == "United States") {
      extraText += `<p>Free delivery over ${this.formatter(this.free_shipping_amount_us)}</p>`;
      // extraText += this.renderShippingDays(this.shipping_days_min_us, this.shipping_days_max_us, this.include_weekends_us);
    } else {
      extraText += `<p>Taxes & shipping calculated at checkout</p>`;
    }
    extraText += `<p>100-day money-back guarantee</p></div>`;
    this.cartFooter.innerHTML += extraText;
  },

  watchCartNote() {
    updateCartGiftMessage = (message) => {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "gift-message": message,
            "gift message": message,
          },
        }),
      })
        .then((response) => {
          if (response.ok) {
            console.log("Gift message updated successfully");
          } else {
            console.error("Failed to update the gift message");
          }
        })
        .catch((error) => {
          console.error("Error updating the gift message:", error);
        });
    };

    this.cartNote.querySelector("textarea").addEventListener("input", () => {
      clearTimeout(this.cartNoteUpdateTimeout);
      this.cartNoteUpdateTimeout = setTimeout(() => {
        const giftMessage = this.cartNote.querySelector("textarea").value.trim();
        if (giftMessage) {
          updateCartGiftMessage(giftMessage);
        }
      }, 2000);
    });

    this.cartNote.querySelector(".cart__note-title").addEventListener("click", (event) => {
      if (this.cartNote.classList.contains("active")) {
        this.cartNote.classList.remove("active");
      } else {
        this.cartNote.classList.add("active");
      }
    });
  },
};
